import { __rest, __assign } from 'tslib';
import React from 'react';
import { PrimaryTabList } from './Component.js';
import { s as styles } from '../../index.module-ee015487.js';
import '@juggle/resize-observer';
import 'classnames';
import '../../../../keyboard-focusable/esm';
import '../../../../shared/esm';
import '../../hooks/use-tabs.js';
import 'react-merge-refs';
import '../scrollable-container/Component.js';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';
import '../title/Component.js';
import '../../../../skeleton/esm';

var PrimaryTabListDesktop = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'm' : _b, restProps = __rest(_a, ["size"]);
    return (React.createElement(PrimaryTabList, __assign({}, restProps, { size: size, styles: styles, platform: 'desktop' })));
};

export { PrimaryTabListDesktop };
